import React, { useState } from 'react';
import Footer from '../../components/Header/Footer';
import Navbar from '../../components/Header/Navbar';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Typography, Tab } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
import GenericSupportForm from './GenericSupportForm';
import SalesSupportForm from './SalesSupportForm';
import { MdCall, MdMailOutline } from 'react-icons/md';

function ContactSupport() {
  useDocumentTitle('Contact Support');

  const [activeTab, setActiveTab] = useState('1');

  return (
    <Box
      sx={{
        '& .contact-input-box': { overflow: 'scroll !important' },
        '& .contact-box': { marginTop: '9rem', marginBottom: '16rem' },

        '@media screen and (max-width: 1080px)': {
          '& .contact-input-box': {
            position: 'initial !important',
            marginTop: '4rem',
          },

          '& .contact-text': { width: 'initial !important' },

          '& .contact-box': {
            marginTop: '2.5rem',
            marginBottom: '2.5rem',
            padding: '3rem 2rem !important',
          },
        },
      }}
    >
      <Navbar />
      <Box
        sx={{
          backgroundColor: 'var(--color-primary)',
          position: 'relative',
          padding: '3rem 4rem',
        }}
        className="contact-box"
      >
        <Stack
          sx={{ color: 'var(--color-primary)', px: '20px', gap: 8, '& *': { color: 'white' } }}
        >
          <Stack>
            <Typography sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'white' }}>
              Let's Connect!
            </Typography>
            <Typography style={{ maxWidth: '440px', opacity: '0.8', color: 'white' }}>
              Do you have any queries/complains, do you want to partner with us, or just give a
              feedback?
            </Typography>
          </Stack>

          <Stack gap={2}>
            <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: 'white' }}>
              We’d love to hear from you.
            </Typography>

            <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.13)',
                  borderRadius: '12px',
                  aspectRatio: 1,
                  width: '44px',
                  height: '44px',
                }}
              >
                <MdMailOutline size={24} />
              </Stack>

              <Stack>
                <Typography variant="body1" color="white">
                  Email us on:
                </Typography>
                <Typography variant="body1" style={{ fontSize: '0.8rem', color: 'white' }}>
                  support@optigrit.com
                </Typography>
              </Stack>
            </Stack>

            <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
              <Stack
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#ffffff20',
                  borderRadius: '12px',
                  aspectRatio: 1,
                  width: '44px',
                  height: '44px',
                }}
              >
                <MdCall size={24} />
              </Stack>

              <Stack>
                <Typography variant="body1" color="white">
                  Call us on:
                </Typography>
                <Typography variant="body1" style={{ fontSize: '0.8rem', color: 'white' }}>
                  +91-9878324029
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Box
          sx={{
            backgroundColor: 'var(--color-bg-secondary)',
            position: 'absolute',
            right: '5rem',
            top: '-8rem',
            color: 'var(--color-text)',
            boxShadow:
              'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
            borderRadius: '1rem',
            maxHeight: 'calc(100vh - 10rem)',
            overflowY: 'auto',

            '& .MuiTabPanel-root': {
              padding: '0',
            },
          }}
          className="contact-input-box"
        >
          <TabContext value={activeTab}>
            <Stack
              sx={{
                position: 'sticky',
                top: '0',
                zIndex: 1,
                backdropFilter: 'blur(10px)',
                padding: '1.5rem',
                paddingBottom: 0,
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 400, fontSize: '1.05rem', marginBottom: '1rem' }}
              >
                What brings you here?
              </Typography>

              <TabList
                onChange={(_, val) => setActiveTab(val)}
                sx={{ marginBottom: '1rem' }}
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Feedback" value="1" />
                <Tab label="Sales Query" value="2" />
                <Tab label="Complaint" value="3" />
                <Tab label="Others" value="4" />
              </TabList>
            </Stack>

            {['1', '3', '4'].map((val) => (
              <TabPanel value={val}>
                <GenericSupportForm />
              </TabPanel>
            ))}

            <TabPanel value="2">
              <SalesSupportForm />
            </TabPanel>
          </TabContext>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

export default ContactSupport;
